import { VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BlogList from "../components/blog_page/BlogList";
import HighlightBlogs from "../components/blog_page/HighlightBlogs";
import LatestPostHero from "../components/blog_page/LatestPostHero";
import { LandingBlogInterface } from "../constants/Blog";
import useCustomToast from "../lib/useCustomToast";
import { axiosPublic } from "../utils/AxiosInstance";
import { PaginationInterface } from "../constants/Pagination";
import { MetaTag } from "../utils/MetaTag";

const Blog = () => {
  const [data, setData] = useState<LandingBlogInterface | undefined>(undefined);
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [pagination, setPagination] = useState<PaginationInterface | undefined>(
    undefined
  );
  const [loaded, setLoaded] = useState<boolean>(false);
  const toast = useCustomToast();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const slugUrl = queryParams.get("category") || "";

  useEffect(() => {
    axiosPublic
      .get(`/v1/landing/blog?page=${page}&search=${search}&category=${slugUrl}`)
      .then((res) => {
        setData(res.data.data);

        setPagination(res.data.data.paginator);
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message || "",
        });
      })
      .finally(() => {
        setLoaded(true);
      });
  }, [slugUrl, page, search]);

  return (
    <VStack
      gap={7}
      px={{
        base: "12px",
        sm: "24px",
        md: "32px",
        lg: "40px",
        xl: "48px",
        "2xl": 0,
      }}
      py="20px"
    >
      <MetaTag
        title="Artikel BisnisLink"
        description="Baca dan bagikan artikel terbaru seputar bisnis, teknologi, dan startup di BisnisLink."
      />

      <LatestPostHero data={data?.primaryBlog} />

      <HighlightBlogs data={data?.highlightedBlog} />

      <BlogList
        data={data?.otherBlogs}
        slugUrl={slugUrl}
        onSearch={(query: string) => {
          setSearch(query);
        }}
        pagination={pagination}
        loaded={loaded}
        onSetPage={(page: number) => setPage(page)}
      />
    </VStack>
  );
};

export default Blog;
